import { PositionOnMapFill18Icon } from "@vygruppen/spor-icon-react";
import { getLabelForAltTransStation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/utils";
import { AltTransTrainRoute } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import styled from "styled-components";
import { Text } from "shared/components/Spor";

type LastVisitedStationProps = {
  trainRoute: AltTransTrainRoute;
};

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 3px;
`;

export const LastVisitedStation: FC<LastVisitedStationProps> = ({
  trainRoute,
}) => (
  <Wrapper>
    <PositionOnMapFill18Icon />
    <Text variant="sm">
      {trainRoute.currentStop?.name ??
        (trainRoute.currentStop
          ? getLabelForAltTransStation(trainRoute.currentStop)
          : "Ukjent")}
    </Text>
  </Wrapper>
);
